module.exports = __webpack_public_path__ + "img/47_2.c07b955b.png";